import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { ProductPreferencesContainer } from "@/screens/Products/containers/ProductPreferencesContainer"
import { ProductStoreProvider } from "@/stores/useProductStore"

const preferenceSearchSchema = z.object({
  companyId: fallback(z.string().optional(), undefined),
})

export const Route: AnyRoute = createFileRoute("/app/product/$productId/preference/")({
  validateSearch: preferenceSearchSchema,
  component: () => (
    <ProductStoreProvider>
      <ProductPreferencesContainer />
    </ProductStoreProvider>
  ),
})
